import { render, staticRenderFns } from "./AttachmentsPreview.vue?vue&type=template&id=d1c8e29a&"
import script from "./AttachmentsPreview.vue?vue&type=script&setup=true&lang=js&"
export * from "./AttachmentsPreview.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports